import { forwardRef, ReactElement, ReactNode, useCallback } from 'react';
import { Input as AntInput, InputProps as AntInputProps } from 'antd';
import * as Styled from './styles';

type TInputProps = Omit<AntInputProps, 'onChange'> & {
  label?: string;
  errorText?: string;
  withClear?: boolean;
  fullWidth?: boolean;
  onChange?: (e: { target: { value: string } }) => void;
  prefix?: ReactNode;
};

export const Input = forwardRef(
  (
    {
      label,
      className,
      errorText,
      withClear,
      fullWidth,
      prefix,
      ...props
    }: TInputProps,
    _ref
  ): ReactElement => {
    const onClear = useCallback(() => {
      props.onChange?.({ target: { value: '' } });
    }, []);

    return (
      <Styled.InputWrapper
        className={className}
        style={props.style}
        $withClear={withClear}
        $fullwidth={fullWidth}
      >
        {label && <Styled.InputLabel>{label}</Styled.InputLabel>}
        {props.type === 'password' ? (
          <AntInput.Password
            className={className}
            size="large"
            bordered
            {...props}
            prefix={prefix}
          />
        ) : (
          <AntInput
            className={className}
            size="large"
            bordered
            {...props}
            prefix={prefix}
          />
        )}
        {!!withClear && !!props.value?.toString().length && (
          <Styled.ClearIcon onClick={onClear} />
        )}
        {props.status === 'error' && (
          <Styled.InputErrorText>{errorText}</Styled.InputErrorText>
        )}
      </Styled.InputWrapper>
    );
  }
);
